var map = {
	"./BlockProduct.svg": 995,
	"./Branch.svg": 996,
	"./CreditCardBanescoLogo.svg": 997,
	"./DELETEselectArrowDown.svg": 998,
	"./DELETEselectArrowUp.svg": 999,
	"./Flags/ad.svg": 1000,
	"./Flags/ae.svg": 1001,
	"./Flags/af.svg": 1002,
	"./Flags/ag.svg": 1003,
	"./Flags/ai.svg": 1004,
	"./Flags/al.svg": 1005,
	"./Flags/am.svg": 1006,
	"./Flags/ao.svg": 1007,
	"./Flags/aq.svg": 1008,
	"./Flags/ar.svg": 1009,
	"./Flags/arab.svg": 1010,
	"./Flags/as.svg": 1011,
	"./Flags/at.svg": 1012,
	"./Flags/au.svg": 1013,
	"./Flags/aw.svg": 1014,
	"./Flags/ax.svg": 1015,
	"./Flags/az.svg": 1016,
	"./Flags/ba.svg": 1017,
	"./Flags/bb.svg": 1018,
	"./Flags/bd.svg": 1019,
	"./Flags/be.svg": 1020,
	"./Flags/bf.svg": 1021,
	"./Flags/bg.svg": 1022,
	"./Flags/bh.svg": 1023,
	"./Flags/bi.svg": 1024,
	"./Flags/bj.svg": 1025,
	"./Flags/bl.svg": 1026,
	"./Flags/bm.svg": 1027,
	"./Flags/bn.svg": 1028,
	"./Flags/bo.svg": 1029,
	"./Flags/bq.svg": 1030,
	"./Flags/br.svg": 1031,
	"./Flags/bs.svg": 1032,
	"./Flags/bt.svg": 1033,
	"./Flags/bv.svg": 1034,
	"./Flags/bw.svg": 1035,
	"./Flags/by.svg": 1036,
	"./Flags/bz.svg": 1037,
	"./Flags/ca.svg": 1038,
	"./Flags/cc.svg": 1039,
	"./Flags/cd.svg": 1040,
	"./Flags/cefta.svg": 1041,
	"./Flags/cf.svg": 1042,
	"./Flags/cg.svg": 1043,
	"./Flags/ch.svg": 1044,
	"./Flags/ci.svg": 1045,
	"./Flags/ck.svg": 1046,
	"./Flags/cl.svg": 1047,
	"./Flags/cm.svg": 1048,
	"./Flags/cn.svg": 1049,
	"./Flags/co.svg": 1050,
	"./Flags/cp.svg": 1051,
	"./Flags/cr.svg": 1052,
	"./Flags/cu.svg": 1053,
	"./Flags/cv.svg": 1054,
	"./Flags/cw.svg": 1055,
	"./Flags/cx.svg": 1056,
	"./Flags/cy.svg": 1057,
	"./Flags/cz.svg": 1058,
	"./Flags/de.svg": 1059,
	"./Flags/dg.svg": 1060,
	"./Flags/dj.svg": 1061,
	"./Flags/dk.svg": 1062,
	"./Flags/dm.svg": 1063,
	"./Flags/do.svg": 1064,
	"./Flags/dz.svg": 1065,
	"./Flags/eac.svg": 1066,
	"./Flags/ec.svg": 1067,
	"./Flags/ee.svg": 1068,
	"./Flags/eg.svg": 1069,
	"./Flags/eh.svg": 1070,
	"./Flags/er.svg": 1071,
	"./Flags/es-ct.svg": 1072,
	"./Flags/es-ga.svg": 1073,
	"./Flags/es-pv.svg": 1074,
	"./Flags/es.svg": 1075,
	"./Flags/et.svg": 1076,
	"./Flags/eu.svg": 1077,
	"./Flags/fi.svg": 1078,
	"./Flags/fj.svg": 1079,
	"./Flags/fk.svg": 1080,
	"./Flags/fm.svg": 1081,
	"./Flags/fo.svg": 1082,
	"./Flags/fr.svg": 1083,
	"./Flags/ga.svg": 1084,
	"./Flags/gb-eng.svg": 1085,
	"./Flags/gb-nir.svg": 1086,
	"./Flags/gb-sct.svg": 1087,
	"./Flags/gb-wls.svg": 1088,
	"./Flags/gb.svg": 1089,
	"./Flags/gd.svg": 1090,
	"./Flags/ge.svg": 1091,
	"./Flags/gf.svg": 1092,
	"./Flags/gg.svg": 1093,
	"./Flags/gh.svg": 1094,
	"./Flags/gi.svg": 1095,
	"./Flags/gl.svg": 1096,
	"./Flags/gm.svg": 1097,
	"./Flags/gn.svg": 1098,
	"./Flags/gp.svg": 1099,
	"./Flags/gq.svg": 1100,
	"./Flags/gr.svg": 1101,
	"./Flags/gs.svg": 1102,
	"./Flags/gt.svg": 1103,
	"./Flags/gu.svg": 1104,
	"./Flags/gw.svg": 1105,
	"./Flags/gy.svg": 1106,
	"./Flags/hk.svg": 1107,
	"./Flags/hm.svg": 1108,
	"./Flags/hn.svg": 1109,
	"./Flags/hr.svg": 1110,
	"./Flags/ht.svg": 1111,
	"./Flags/hu.svg": 1112,
	"./Flags/ic.svg": 1113,
	"./Flags/id.svg": 1114,
	"./Flags/ie.svg": 1115,
	"./Flags/il.svg": 1116,
	"./Flags/im.svg": 1117,
	"./Flags/in.svg": 1118,
	"./Flags/io.svg": 1119,
	"./Flags/iq.svg": 1120,
	"./Flags/ir.svg": 1121,
	"./Flags/is.svg": 1122,
	"./Flags/it.svg": 1123,
	"./Flags/je.svg": 1124,
	"./Flags/jm.svg": 1125,
	"./Flags/jo.svg": 1126,
	"./Flags/jp.svg": 1127,
	"./Flags/ke.svg": 1128,
	"./Flags/kg.svg": 1129,
	"./Flags/kh.svg": 1130,
	"./Flags/ki.svg": 1131,
	"./Flags/km.svg": 1132,
	"./Flags/kn.svg": 1133,
	"./Flags/kp.svg": 1134,
	"./Flags/kr.svg": 1135,
	"./Flags/kw.svg": 1136,
	"./Flags/ky.svg": 1137,
	"./Flags/kz.svg": 1138,
	"./Flags/la.svg": 1139,
	"./Flags/lb.svg": 1140,
	"./Flags/lc.svg": 1141,
	"./Flags/li.svg": 1142,
	"./Flags/lk.svg": 1143,
	"./Flags/lr.svg": 1144,
	"./Flags/ls.svg": 1145,
	"./Flags/lt.svg": 1146,
	"./Flags/lu.svg": 1147,
	"./Flags/lv.svg": 1148,
	"./Flags/ly.svg": 1149,
	"./Flags/ma.svg": 1150,
	"./Flags/mc.svg": 1151,
	"./Flags/md.svg": 1152,
	"./Flags/me.svg": 1153,
	"./Flags/mf.svg": 1154,
	"./Flags/mg.svg": 1155,
	"./Flags/mh.svg": 1156,
	"./Flags/mk.svg": 1157,
	"./Flags/ml.svg": 1158,
	"./Flags/mm.svg": 1159,
	"./Flags/mn.svg": 1160,
	"./Flags/mo.svg": 1161,
	"./Flags/mp.svg": 1162,
	"./Flags/mq.svg": 1163,
	"./Flags/mr.svg": 1164,
	"./Flags/ms.svg": 1165,
	"./Flags/mt.svg": 1166,
	"./Flags/mu.svg": 1167,
	"./Flags/mv.svg": 1168,
	"./Flags/mw.svg": 1169,
	"./Flags/mx.svg": 1170,
	"./Flags/my.svg": 1171,
	"./Flags/mz.svg": 1172,
	"./Flags/na.svg": 1173,
	"./Flags/nc.svg": 1174,
	"./Flags/ne.svg": 1175,
	"./Flags/nf.svg": 1176,
	"./Flags/ng.svg": 1177,
	"./Flags/ni.svg": 1178,
	"./Flags/nl.svg": 1179,
	"./Flags/no.svg": 1180,
	"./Flags/np.svg": 1181,
	"./Flags/nr.svg": 1182,
	"./Flags/nu.svg": 1183,
	"./Flags/nz.svg": 1184,
	"./Flags/om.svg": 1185,
	"./Flags/pa.svg": 1186,
	"./Flags/pc.svg": 1187,
	"./Flags/pe.svg": 1188,
	"./Flags/pf.svg": 1189,
	"./Flags/pg.svg": 1190,
	"./Flags/ph.svg": 1191,
	"./Flags/pk.svg": 1192,
	"./Flags/pl.svg": 1193,
	"./Flags/pm.svg": 1194,
	"./Flags/pn.svg": 1195,
	"./Flags/pr.svg": 1196,
	"./Flags/ps.svg": 1197,
	"./Flags/pt.svg": 1198,
	"./Flags/pw.svg": 1199,
	"./Flags/py.svg": 1200,
	"./Flags/qa.svg": 1201,
	"./Flags/re.svg": 1202,
	"./Flags/ro.svg": 1203,
	"./Flags/rs.svg": 1204,
	"./Flags/ru.svg": 1205,
	"./Flags/rw.svg": 1206,
	"./Flags/sa.svg": 1207,
	"./Flags/sb.svg": 1208,
	"./Flags/sc.svg": 1209,
	"./Flags/sd.svg": 1210,
	"./Flags/se.svg": 1211,
	"./Flags/sg.svg": 1212,
	"./Flags/sh-ac.svg": 1213,
	"./Flags/sh-hl.svg": 1214,
	"./Flags/sh-ta.svg": 1215,
	"./Flags/sh.svg": 1216,
	"./Flags/si.svg": 1217,
	"./Flags/sj.svg": 1218,
	"./Flags/sk.svg": 1219,
	"./Flags/sl.svg": 1220,
	"./Flags/sm.svg": 1221,
	"./Flags/sn.svg": 1222,
	"./Flags/so.svg": 1223,
	"./Flags/sr.svg": 1224,
	"./Flags/ss.svg": 1225,
	"./Flags/st.svg": 1226,
	"./Flags/sv.svg": 1227,
	"./Flags/sx.svg": 1228,
	"./Flags/sy.svg": 1229,
	"./Flags/sz.svg": 1230,
	"./Flags/tc.svg": 1231,
	"./Flags/td.svg": 1232,
	"./Flags/tf.svg": 1233,
	"./Flags/tg.svg": 1234,
	"./Flags/th.svg": 1235,
	"./Flags/tj.svg": 1236,
	"./Flags/tk.svg": 1237,
	"./Flags/tl.svg": 1238,
	"./Flags/tm.svg": 1239,
	"./Flags/tn.svg": 1240,
	"./Flags/to.svg": 1241,
	"./Flags/tr.svg": 1242,
	"./Flags/tt.svg": 1243,
	"./Flags/tv.svg": 1244,
	"./Flags/tw.svg": 1245,
	"./Flags/tz.svg": 1246,
	"./Flags/ua.svg": 1247,
	"./Flags/ug.svg": 1248,
	"./Flags/um.svg": 1249,
	"./Flags/un.svg": 1250,
	"./Flags/us.svg": 1251,
	"./Flags/uy.svg": 1252,
	"./Flags/uz.svg": 1253,
	"./Flags/va.svg": 1254,
	"./Flags/vc.svg": 1255,
	"./Flags/ve.svg": 1256,
	"./Flags/vg.svg": 1257,
	"./Flags/vi.svg": 1258,
	"./Flags/vn.svg": 1259,
	"./Flags/vu.svg": 1260,
	"./Flags/wf.svg": 1261,
	"./Flags/ws.svg": 1262,
	"./Flags/xk.svg": 1263,
	"./Flags/xx.svg": 1264,
	"./Flags/ye.svg": 1265,
	"./Flags/yt.svg": 1266,
	"./Flags/za.svg": 1267,
	"./Flags/zm.svg": 1268,
	"./Flags/zw.svg": 1269,
	"./ID.svg": 1270,
	"./InvitationCode.svg": 1271,
	"./LoginBarFingerPrint.svg": 1272,
	"./LoginBarToken.svg": 1273,
	"./Stop.svg": 1274,
	"./Union.svg": 1275,
	"./UnlockProduct.svg": 1276,
	"./add-contact.svg": 1277,
	"./administrar.svg": 1278,
	"./administration.svg": 1279,
	"./administrator.svg": 1280,
	"./adornmentCards.svg": 1281,
	"./agenda.svg": 1282,
	"./alert-big.svg": 1283,
	"./alert.svg": 1284,
	"./applePay.svg": 1285,
	"./applePayBanner.svg": 1286,
	"./arrow-down.svg": 1287,
	"./arrow-right.svg": 1288,
	"./arrowLeft.svg": 1289,
	"./arrowRight.svg": 1290,
	"./arrowRightLight.svg": 1291,
	"./attach.svg": 1292,
	"./attachment.svg": 1293,
	"./avatarImages/avatar-0.svg": 1294,
	"./avatarImages/avatar-1.svg": 1295,
	"./avatarImages/avatar-10.svg": 1296,
	"./avatarImages/avatar-11.svg": 1297,
	"./avatarImages/avatar-2.svg": 1298,
	"./avatarImages/avatar-3.svg": 1299,
	"./avatarImages/avatar-4.svg": 1300,
	"./avatarImages/avatar-5.svg": 1301,
	"./avatarImages/avatar-6.svg": 1302,
	"./avatarImages/avatar-7.svg": 1303,
	"./avatarImages/avatar-8.svg": 1304,
	"./avatarImages/avatar-9.svg": 1305,
	"./banesco-icon.svg": 1306,
	"./banesco-mobile-logo-color.svg": 1307,
	"./banesco-mobile-logo.svg": 1308,
	"./bell.svg": 1309,
	"./bioIcon.svg": 1310,
	"./bk_chart.svg": 1311,
	"./block-balances.svg": 1312,
	"./calendar-plus.svg": 1313,
	"./campaigns/PersonasJuridicas.png": 1314,
	"./campaigns/campaignDefault.png": 1315,
	"./campaigns/connectMilesBanner.png": 1316,
	"./cancel_red.svg": 1317,
	"./carLoan.svg": 1318,
	"./channel-atm.svg": 1319,
	"./channel-bank.svg": 1320,
	"./channel-check.svg": 1321,
	"./channel-generic.svg": 1322,
	"./channel-kuara.svg": 1323,
	"./channel-mobile.svg": 1324,
	"./channel-transfers.svg": 1325,
	"./channel-walle.svg": 1326,
	"./channel-wally.svg": 1327,
	"./channel-web.svg": 1328,
	"./check-circle-kuara.svg": 1329,
	"./check-circle.svg": 1330,
	"./check-ticket.svg": 1331,
	"./check.svg": 1332,
	"./checkAccordion.svg": 1333,
	"./checkCheckbox.svg": 1334,
	"./chevromLeft.svg": 1335,
	"./chevromRight.svg": 1336,
	"./chevronDown.svg": 1337,
	"./circle-question.svg": 1338,
	"./client.svg": 1339,
	"./clock-notebook-purple.svg": 1340,
	"./clock-notebook.svg": 1341,
	"./cloud-download.svg": 1342,
	"./collapse-sidebar.svg": 1343,
	"./coloredIcons/agenda.svg": 1344,
	"./coloredIcons/alert.svg": 1345,
	"./coloredIcons/browser-not-available.svg": 1346,
	"./coloredIcons/chronometer.svg": 1347,
	"./coloredIcons/credit-card-expired.svg": 1348,
	"./coloredIcons/creditCards.svg": 1349,
	"./coloredIcons/deposits.svg": 1350,
	"./coloredIcons/desktop.svg": 1351,
	"./coloredIcons/device-not-available.svg": 1352,
	"./coloredIcons/doc.svg": 1353,
	"./coloredIcons/failure.svg": 1354,
	"./coloredIcons/folder-empty.svg": 1355,
	"./coloredIcons/folder.svg": 1356,
	"./coloredIcons/loan-expired.svg": 1357,
	"./coloredIcons/loans.svg": 1358,
	"./coloredIcons/lock.svg": 1359,
	"./coloredIcons/mailbox-empty.svg": 1360,
	"./coloredIcons/mailbox.svg": 1361,
	"./coloredIcons/messenger.svg": 1362,
	"./coloredIcons/money-red.svg": 1363,
	"./coloredIcons/money.svg": 1364,
	"./coloredIcons/no-connection-gray.svg": 1365,
	"./coloredIcons/no-connection.svg": 1366,
	"./coloredIcons/no-more-transactions.svg": 1367,
	"./coloredIcons/notifications-empty.svg": 1368,
	"./coloredIcons/notifications.svg": 1369,
	"./coloredIcons/search-no-results.svg": 1370,
	"./coloredIcons/search.svg": 1371,
	"./coloredIcons/setup.svg": 1372,
	"./coloredIcons/success.svg": 1373,
	"./coloredIcons/transfer.svg": 1374,
	"./coloredIcons/user.svg": 1375,
	"./coloredIcons/wallet.svg": 1376,
	"./commerce.svg": 1377,
	"./contact-kuara.svg": 1378,
	"./contact-wally.svg": 1379,
	"./contextualMenu.svg": 1380,
	"./creditCard.svg": 1381,
	"./creditCardWarning.svg": 1382,
	"./cross-primary.svg": 1383,
	"./cross.svg": 1384,
	"./crossMask.svg": 1385,
	"./cross_viejo.svg": 1386,
	"./cuentas.svg": 1387,
	"./currencyFlags/ARS.svg": 1388,
	"./currencyFlags/BRL.svg": 1389,
	"./currencyFlags/CAD.svg": 1390,
	"./currencyFlags/CHF.svg": 1391,
	"./currencyFlags/CLP.svg": 1392,
	"./currencyFlags/CNH.svg": 1393,
	"./currencyFlags/EUR.svg": 1394,
	"./currencyFlags/GBP.svg": 1395,
	"./currencyFlags/HKD.svg": 1396,
	"./currencyFlags/JPY.svg": 1397,
	"./currencyFlags/MXN.svg": 1398,
	"./currencyFlags/USD.svg": 1399,
	"./currencyFlags/UYI.svg": 1400,
	"./currencyFlags/UYU.svg": 1401,
	"./delete-message.svg": 1402,
	"./desktop.svg": 1403,
	"./documentIcon.svg": 1404,
	"./download.svg": 1405,
	"./dropdown-arrow.svg": 1406,
	"./editPen.svg": 1407,
	"./electricity.svg": 1408,
	"./email.svg": 1409,
	"./en-flag.svg": 1410,
	"./error.svg": 1411,
	"./errorShield.svg": 1412,
	"./es-flag-old.svg": 1413,
	"./es-flag.svg": 1414,
	"./escritorio.svg": 1415,
	"./exclamation.svg": 1416,
	"./expand-sidebar.svg": 1417,
	"./eyeLooking.svg": 1418,
	"./faceOverlay.svg": 1419,
	"./faceOverlayDesktop.svg": 1420,
	"./facebookLogo.svg": 1421,
	"./fileIconsByExtension/file-bmp.svg": 1422,
	"./fileIconsByExtension/file-default.svg": 1423,
	"./fileIconsByExtension/file-doc.svg": 1424,
	"./fileIconsByExtension/file-gif.svg": 1425,
	"./fileIconsByExtension/file-jpg.svg": 1426,
	"./fileIconsByExtension/file-pdf.svg": 1427,
	"./fileIconsByExtension/file-png.svg": 1428,
	"./fileIconsByExtension/file-ppt.svg": 1429,
	"./fileIconsByExtension/file-txt.svg": 1430,
	"./fileIconsByExtension/file-xls.svg": 1431,
	"./financialInstitution.svg": 533,
	"./frecuentDestination.svg": 1432,
	"./gif/piggyPlane.gif": 534,
	"./headerCommandsMobile.svg": 1433,
	"./headerCommandsMobile_old.svg": 1434,
	"./hide.svg": 1435,
	"./home.svg": 1436,
	"./icons/MbBanescoContigoLogo.svg": 1437,
	"./icons/MbBanescoLogo.svg": 1438,
	"./icons/accordionArrow.svg": 1439,
	"./icons/arrowDown.svg": 1440,
	"./icons/arrowLeft.svg": 1441,
	"./icons/attachment.svg": 1442,
	"./icons/bell.svg": 1443,
	"./icons/bigCheck.svg": 1444,
	"./icons/breadCrumbArrow.svg": 1445,
	"./icons/bullet.svg": 1446,
	"./icons/calendarTime.svg": 1447,
	"./icons/calendarTimeDisclaimer.svg": 1448,
	"./icons/cameraToken.svg": 1449,
	"./icons/chartCircle.svg": 1450,
	"./icons/chartCirclePayed.svg": 1451,
	"./icons/chatDani.svg": 1452,
	"./icons/chatIcon.svg": 1453,
	"./icons/chatWithVane.svg": 1454,
	"./icons/checkBox.svg": 1455,
	"./icons/checkedRing.svg": 1456,
	"./icons/chevronDown.svg": 1457,
	"./icons/chevronRight.svg": 1458,
	"./icons/circleCheck.svg": 1459,
	"./icons/circleCross.svg": 1460,
	"./icons/circleCross16.svg": 1461,
	"./icons/circleCross2.svg": 1462,
	"./icons/circlePlus.svg": 1463,
	"./icons/circlePlusEvenOdd.svg": 1464,
	"./icons/circleQuestion.svg": 1465,
	"./icons/clockShield.svg": 1466,
	"./icons/configuration.svg": 1467,
	"./icons/contactUs.svg": 1468,
	"./icons/contextualMenu.svg": 1469,
	"./icons/corporateBuildingBig.svg": 1470,
	"./icons/creditCard-band.svg": 1471,
	"./icons/creditCard-card.svg": 1472,
	"./icons/creditCard-sticker.svg": 1473,
	"./icons/creditCardsTransit.svg": 1474,
	"./icons/cross16.svg": 1475,
	"./icons/datePickerCalendar.svg": 1476,
	"./icons/deleteTrash.svg": 1477,
	"./icons/deleteTrash24.svg": 1478,
	"./icons/directory.svg": 1479,
	"./icons/disclaimerError.svg": 1480,
	"./icons/documentToken.svg": 1481,
	"./icons/download.svg": 1482,
	"./icons/editPen.svg": 1483,
	"./icons/editPen16.svg": 1484,
	"./icons/editPen24.svg": 1485,
	"./icons/enviroment-corporate.svg": 1486,
	"./icons/enviroment-retail.svg": 1487,
	"./icons/error.svg": 1488,
	"./icons/errorIcon.svg": 1489,
	"./icons/errorShield.svg": 1490,
	"./icons/errors/duplicatedPig.svg": 1491,
	"./icons/errors/error.svg": 1492,
	"./icons/errors/maintenanceTasks.svg": 1493,
	"./icons/errors/noConection.svg": 1494,
	"./icons/errors/transactionTimeOut.svg": 1495,
	"./icons/errors/uppdate.svg": 1496,
	"./icons/favoriteStarOff.svg": 1497,
	"./icons/favoriteStarOn.svg": 1498,
	"./icons/fingerprintLogin.svg": 1499,
	"./icons/flags/CAD.svg": 1500,
	"./icons/flags/CHF.svg": 1501,
	"./icons/flags/CNH.svg": 1502,
	"./icons/flags/CNY.svg": 1503,
	"./icons/flags/EUR.svg": 1504,
	"./icons/flags/GBP.svg": 1505,
	"./icons/flags/HKD.svg": 1506,
	"./icons/flags/JPY.svg": 1507,
	"./icons/flags/MXN.svg": 1508,
	"./icons/flags/USD.svg": 1509,
	"./icons/glasses.svg": 1510,
	"./icons/hidePass.svg": 1511,
	"./icons/home.svg": 1512,
	"./icons/inInputClose.svg": 1513,
	"./icons/inSelectArrowDown.svg": 1514,
	"./icons/inSelectArrowUp.svg": 1515,
	"./icons/info.svg": 1516,
	"./icons/infoIcon.svg": 1517,
	"./icons/key.svg": 1518,
	"./icons/loading.svg": 1519,
	"./icons/lock.svg": 1520,
	"./icons/locked.svg": 1521,
	"./icons/logOut.svg": 1522,
	"./icons/login.svg": 1523,
	"./icons/markerLocation.svg": 1524,
	"./icons/menu-administration.svg": 1525,
	"./icons/menu-credit-card-management.svg": 1526,
	"./icons/menu-directory.svg": 1527,
	"./icons/menu-enviroment-corporate.svg": 1528,
	"./icons/menu-enviroment-retail.svg": 1529,
	"./icons/menu-home.svg": 1530,
	"./icons/menu-payments.svg": 1531,
	"./icons/menu-pending-transactions.svg": 1532,
	"./icons/menu-products.svg": 1533,
	"./icons/menu-profile.svg": 1534,
	"./icons/menu-requests.svg": 1535,
	"./icons/menu-security.svg": 1536,
	"./icons/menu-settings.svg": 1537,
	"./icons/menu-transactions.svg": 1538,
	"./icons/menu-transfers.svg": 1539,
	"./icons/menu-wally.svg": 1540,
	"./icons/menu-your-finances.svg": 1541,
	"./icons/modalClose.svg": 1542,
	"./icons/noWidgets.svg": 1543,
	"./icons/onlineShift.svg": 1544,
	"./icons/passportToken.svg": 1545,
	"./icons/pauseSmall.svg": 1546,
	"./icons/plus-circle.svg": 1547,
	"./icons/print.svg": 1548,
	"./icons/productTypeCA.svg": 1549,
	"./icons/productTypeCC.svg": 1550,
	"./icons/productTypeCar.svg": 1551,
	"./icons/productTypeCash.svg": 1552,
	"./icons/productTypeComercial.svg": 1553,
	"./icons/productTypeCreditLine.svg": 1554,
	"./icons/productTypeHouse.svg": 1555,
	"./icons/productTypeLight.svg": 1556,
	"./icons/productTypeLock.svg": 1557,
	"./icons/productTypePA.svg": 1558,
	"./icons/productTypePF.svg": 1559,
	"./icons/productTypeSheet.svg": 1560,
	"./icons/productTypecreditCard.svg": 1561,
	"./icons/qrCode.svg": 1562,
	"./icons/readMessage.svg": 1563,
	"./icons/reloadIcon.svg": 1564,
	"./icons/reloadIconWhite.svg": 1565,
	"./icons/requests.svg": 1566,
	"./icons/retry.svg": 1567,
	"./icons/ring.svg": 1568,
	"./icons/sb-close.svg": 1569,
	"./icons/sb-error.svg": 1570,
	"./icons/sb-info.svg": 1571,
	"./icons/sb-success.svg": 1572,
	"./icons/sb-warning.svg": 1573,
	"./icons/servicesCategories/business.svg": 1574,
	"./icons/servicesCategories/education.svg": 1575,
	"./icons/servicesCategories/government.svg": 1576,
	"./icons/servicesCategories/insurance.svg": 1577,
	"./icons/servicesCategories/publicServices.svg": 1578,
	"./icons/servicesCategories/recharges.svg": 1579,
	"./icons/servicesCategories/telecommunications.svg": 1580,
	"./icons/settings.svg": 1581,
	"./icons/share.svg": 1582,
	"./icons/show.svg": 1583,
	"./icons/showOff.svg": 1584,
	"./icons/showPass.svg": 1585,
	"./icons/signatures.svg": 1586,
	"./icons/signaturesSchemesEmpty.svg": 1587,
	"./icons/sliderArrowLeft.svg": 1588,
	"./icons/sliderArrowRight.svg": 1589,
	"./icons/step0login.svg": 1590,
	"./icons/stepperCheck.svg": 1591,
	"./icons/stopSmall.svg": 1592,
	"./icons/stopwatch.svg": 1593,
	"./icons/successBig.svg": 1594,
	"./icons/successIcon.svg": 1595,
	"./icons/successShield.svg": 1596,
	"./icons/sunEclipse.svg": 1597,
	"./icons/template.svg": 1598,
	"./icons/thunder.svg": 1599,
	"./icons/ticketSignatureCanceled.svg": 1600,
	"./icons/ticketSignatureCheck.svg": 1601,
	"./icons/ticketSignatureEmpty.svg": 1602,
	"./icons/tickets/error.svg": 1603,
	"./icons/tickets/partial.svg": 1604,
	"./icons/tickets/pending.svg": 1605,
	"./icons/tickets/processing.svg": 1606,
	"./icons/tickets/success-scheduled.svg": 1607,
	"./icons/tickets/success.svg": 1608,
	"./icons/token/documentToken.svg": 1609,
	"./icons/token/passportToken.svg": 1610,
	"./icons/tooltip.svg": 1611,
	"./icons/transfersArrow.svg": 1612,
	"./icons/trash-wally.svg": 1613,
	"./icons/trash.svg": 1614,
	"./icons/trashDelete.svg": 1615,
	"./icons/tv.svg": 1616,
	"./icons/union.svg": 1617,
	"./icons/unlock.svg": 1618,
	"./icons/unreadMessage.svg": 1619,
	"./icons/upload.svg": 1620,
	"./icons/user-plus.svg": 1621,
	"./icons/user.svg": 1622,
	"./icons/userEditPencil.svg": 1623,
	"./icons/userIcon.svg": 1624,
	"./icons/userPlus.svg": 1625,
	"./icons/userToken.svg": 1626,
	"./icons/userTokenDashedLine.svg": 1627,
	"./icons/userTokenWarning.svg": 1628,
	"./icons/usersSmallBig.svg": 1629,
	"./icons/wallyNoContacts.svg": 1630,
	"./icons/warning.svg": 1631,
	"./icons/warningBlack.svg": 1632,
	"./icons/warningIcon.svg": 1633,
	"./icons/warningShield.svg": 1634,
	"./inSelectArrowDown.svg": 1635,
	"./inbox.svg": 1636,
	"./indeterminate.svg": 1637,
	"./kuaraDescription.svg": 1638,
	"./kuaraModal.svg": 1639,
	"./last-movements.svg": 1640,
	"./left-arrow.svg": 1641,
	"./listIconPoi1.svg": 1642,
	"./listIconPoi2.svg": 1643,
	"./listIconPoi3.svg": 1644,
	"./location.svg": 1645,
	"./logo-banesco.svg": 1646,
	"./logoCompany.svg": 1647,
	"./logos/Master.svg": 1648,
	"./logos/Visa.svg": 1649,
	"./logos/banescoLogoB&WBG.svg": 1650,
	"./logos/banescoLogoBG.svg": 1651,
	"./logos/kuaraAccessBarLogo.svg": 1652,
	"./logos/kuaraHorizontal.svg": 1653,
	"./logos/kuaraHorizontalSmall.svg": 1654,
	"./logos/kuaraLogoBGDown.svg": 1655,
	"./logos/kuaraLogoBGUp.svg": 1656,
	"./logos/loadLogo.svg": 1657,
	"./logos/logo-tekbnk.svg": 1658,
	"./logos/logoTicketBG.png": 420,
	"./logos/logoTicketFooter.png": 421,
	"./logos/logoWallyPDF.png": 535,
	"./logos/menu-banesco-logo-bg.svg": 1659,
	"./logos/ticket-logo-banesco.svg": 1660,
	"./logout-mobile.svg": 1661,
	"./markerFilter1.svg": 1662,
	"./markerFilter2.svg": 1663,
	"./markerFilter3.svg": 1664,
	"./markerLocation.svg": 327,
	"./mastercard-creditCard.svg": 1665,
	"./mastercard-debitCard.svg": 1666,
	"./mastercard.svg": 1667,
	"./menuLogoBanesco.svg": 1668,
	"./message-icon.svg": 1669,
	"./messagesImages/web-construction-mobile.svg": 1670,
	"./messagesImages/web-construction.svg": 1671,
	"./minus.svg": 1672,
	"./mobile.svg": 1673,
	"./mobileCommands.svg": 1674,
	"./mobileDashboardTour/chevronTourLeft.svg": 1675,
	"./mobileDashboardTour/chevronTourRight.svg": 1676,
	"./mobileDashboardTour/corporateStep1.svg": 1677,
	"./mobileDashboardTour/corporateStep2.svg": 1678,
	"./mobileDashboardTour/corporateStep3.svg": 1679,
	"./mobileDashboardTour/corporateStep4.svg": 1680,
	"./mobileDashboardTour/corporateStep5.svg": 1681,
	"./mobileDashboardTour/corporateStep6.svg": 1682,
	"./mobileDashboardTour/corporateStep7.svg": 1683,
	"./mobileDashboardTour/step1.svg": 1684,
	"./mobileDashboardTour/step2.svg": 1685,
	"./mobileDashboardTour/step3.svg": 1686,
	"./mobileDashboardTour/step4.svg": 1687,
	"./mobileDashboardTour/step5.svg": 1688,
	"./movTransit.svg": 1689,
	"./movements.svg": 1690,
	"./newUser.svg": 1691,
	"./newUserCorp.svg": 1692,
	"./no-connection.svg": 1693,
	"./note.svg": 1694,
	"./pagos.svg": 1695,
	"./pagos_viejo.svg": 1696,
	"./passportEnrollment.svg": 1697,
	"./pause.svg": 1698,
	"./pending-actions.svg": 1699,
	"./pending-dispatch.svg": 1700,
	"./perfil.svg": 1701,
	"./personalLoan.svg": 1702,
	"./phone-cash.svg": 1703,
	"./place.svg": 1704,
	"./play.svg": 1705,
	"./plus-icon.svg": 1706,
	"./plus.svg": 1707,
	"./plusCircle.svg": 1708,
	"./posicionConsolidada.svg": 1709,
	"./preApproved/preApprovedCar.svg": 1710,
	"./preApproved/preApprovedCreditCard.svg": 1711,
	"./preApproved/preApprovedMoney.svg": 1712,
	"./preApproved/preApprovedPig.svg": 1713,
	"./prestamos.svg": 1714,
	"./print-id.svg": 1715,
	"./process.svg": 1716,
	"./product-request-acces-bar.svg": 1717,
	"./product-request.svg": 1718,
	"./pt-flag.svg": 1719,
	"./qrCodes/qrEnollmentCode.svg": 1720,
	"./radioButtonMark.svg": 1721,
	"./read.svg": 1722,
	"./request-wally.svg": 1723,
	"./requests.svg": 1724,
	"./retail.svg": 1725,
	"./retailed.svg": 1726,
	"./rocket.svg": 1727,
	"./schedule.svg": 1728,
	"./search.svg": 1729,
	"./security-image.svg": 1730,
	"./selectArrowDown.svg": 1731,
	"./selectArrowUp.svg": 1732,
	"./selfie-icon.svg": 1733,
	"./send-up.svg": 1734,
	"./settings-access-bar.svg": 1735,
	"./settings-kuara.svg": 1736,
	"./settings-wally.svg": 1737,
	"./settings.svg": 1738,
	"./shortCutBtn/SCBForeign.svg": 1739,
	"./shortCutBtn/SCBaccounts.svg": 1740,
	"./shortCutBtn/SCBbag.svg": 1741,
	"./shortCutBtn/SCBcard.svg": 1742,
	"./shortCutBtn/SCBcardPayment.svg": 1743,
	"./shortCutBtn/SCBconfig.svg": 1744,
	"./shortCutBtn/SCBlamp.svg": 1745,
	"./shortCutBtn/SCBlowBat.svg": 1746,
	"./shortCutBtn/SCBmovement.svg": 1747,
	"./shortCutBtn/SCBpayments.svg": 1748,
	"./shortCutBtn/SCBpaymentsMobile.svg": 1749,
	"./shortCutBtn/SCBpending.svg": 1750,
	"./shortCutBtn/SCBpig.svg": 1751,
	"./shortCutBtn/SCBplus.svg": 1752,
	"./shortCutBtn/SCBproducts.svg": 1753,
	"./shortCutBtn/SCBrequest.svg": 1754,
	"./shortCutBtn/SCBsecurity.svg": 1755,
	"./shortCutBtn/SCBsecurityMobile.svg": 1756,
	"./shortCutBtn/SCBsend.svg": 1757,
	"./shortCutBtn/SCBsettings.svg": 1758,
	"./shortCutBtn/SCBthirdParties.svg": 1759,
	"./shortCutBtn/SCBworld.svg": 1760,
	"./show.svg": 1761,
	"./showOff.svg": 1762,
	"./sliderLeftArrow.svg": 1763,
	"./sliderRightArrow.svg": 1764,
	"./smartphone-cancel-wally.svg": 1765,
	"./smartphone-text-wally.svg": 1766,
	"./smartphone-wally.svg": 1767,
	"./socialIcons/facebook.svg": 1768,
	"./socialIcons/instagram.svg": 1769,
	"./socialIcons/linkedin.svg": 1770,
	"./socialIcons/twitter.svg": 1771,
	"./socialIcons/youtube.svg": 1772,
	"./splashScreen/splashScreenImage.png": 1773,
	"./star-off.svg": 1774,
	"./star.svg": 1775,
	"./styledChevromRight.svg": 1776,
	"./styledClose.svg": 1777,
	"./styledDatepicker-Chevrom-Left.svg": 1778,
	"./styledDatepicker-Chevrom-Right.svg": 1779,
	"./styledSchedule.svg": 1780,
	"./styledmenu-arrow-down-evenodd.svg": 1781,
	"./styledmenu-arrow-down-heading-color.svg": 1782,
	"./styledmenu-arrow-down-primary.svg": 1783,
	"./styledmenu-arrow-down-white.svg": 1784,
	"./styledmenu-arrow-down.svg": 1785,
	"./styledmenu-arrow-up.svg": 1786,
	"./styledmenu-close-white.svg": 1787,
	"./styledmenu-close.svg": 1788,
	"./success.svg": 1789,
	"./successRadious.svg": 1790,
	"./tablet-android.svg": 1791,
	"./tablet-ipad.svg": 1792,
	"./tablet.svg": 1793,
	"./take-picture.svg": 1794,
	"./tarjetas.svg": 1795,
	"./tarjetas_viejo.svg": 1796,
	"./template.svg": 1797,
	"./ticketStatusIcons/alert.svg": 1798,
	"./ticketStatusIcons/check.svg": 1799,
	"./ticketStatusIcons/cross.svg": 1800,
	"./ticketStatusIcons/draft.svg": 1801,
	"./ticketStatusIcons/process.svg": 1802,
	"./ticketStatusIcons/schedule.svg": 1803,
	"./ticketStatusIcons/sign.svg": 1804,
	"./toggleMenu.svg": 1805,
	"./toggleMenuWhite.svg": 1806,
	"./tooltip-icon.svg": 1807,
	"./tour/tourCreditCards.svg": 1808,
	"./transaction-list.svg": 1809,
	"./transactionStatusIcons/alert.svg": 1810,
	"./transactionStatusIcons/check.svg": 1811,
	"./transactionStatusIcons/cross.svg": 1812,
	"./transactionStatusIcons/draft.svg": 1813,
	"./transactionStatusIcons/process.svg": 1814,
	"./transactionStatusIcons/schedule.svg": 1815,
	"./transactionStatusIcons/sign.svg": 1816,
	"./transactions.svg": 1817,
	"./transferencias.svg": 1818,
	"./transfers-tooltip.svg": 1819,
	"./trash.svg": 1820,
	"./ubicacion.png": 1821,
	"./uk-flag.svg": 1822,
	"./user-plus.svg": 1823,
	"./user.svg": 1824,
	"./uy-flag.svg": 1825,
	"./visa-blue-creditCard.svg": 1826,
	"./visa-creditCard.svg": 1827,
	"./visa-debitCard.svg": 1828,
	"./visa.svg": 1829,
	"./wally-head.svg": 1830,
	"./wally-orange.svg": 1831,
	"./wally.svg": 1832,
	"./wallyDescription.svg": 1833,
	"./warning-login.svg": 1834,
	"./warningIcon.svg": 1835
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 994;